"use strict";
import axios from "axios";

// every request to the server must send
// "Authorization" : "Bearer ${token}"
// to tell the server the request is from
// an authorised user

export default class Auth {
  register(user) {
    return axios.post("/register", user, {
      accept: "application/json"
    });
  }

  authHeader(accept) {
    // let user = store.getters.getUser
    let token = JSON.parse(sessionStorage.getItem("token"));
    if (token && token.token) {
      if (accept == "json") {
        return {
          accept: "application/json",
          Authorization: "Bearer " + token.token
        };
      }
      return { Authorization: "Bearer " + token.token };
    } else {
      return {};
    }
  }

  login(credential) {
    return axios.post("/auth/login", credential, {
      accept: "application/json"
    });
  }

  logout() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
  }

  check() {
    if (localStorage.getItem("token") === null) {
      this.destroy();
    } else if (localStorage.getItem("token") !== null) {
      let localToken = localStorage.getItem("token");
      localToken = JSON.parse(localToken);
      localToken = localToken.access_token;

      axios
        .get("/auth/user", {
          headers: {
            Authorization: "Bearer " + localToken
          }
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(err => {
          this.destroy();
        });
    } else {
    }
  }

  destroy() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");

    swal({
      text: "Your token is invalid. Please login again.",
      icon: "error",
      button: "OK"
    }).then(function() {
      window.location = "login";
    });
  }

  user() {
    return JSON.parse(sessionStorage.getItem("user"));
  }
}
